module.exports = __webpack_public_path__ + "static/img/IMG_2155.da2cb13.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/talalok/IMG_2155.jpg
// module id = 614
// module chunks = 0